export const booksOfAccountsMembersModalFilterState = () => ({
  page: 1,
  perPage: 10
});
